import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { gsap } from 'gsap'

const splitHeroText = (text) => {
  // remove H1
  const noH1 = text.replace(/<[/\n\r]*h1[^>]*>/g, '')

  // split text by <br /> tag
  const splitText = noH1.split('<br />')

  // add span tags and H1 tags
  let finalSplit = ''
  splitText.forEach(
    (x, index) =>
      (finalSplit += `${index === 0 ? '<h1>' : ''}
        <span><span>${x}</span></span>
        ${index === splitText.length - 1 ? '</h1>' : ''}`)
  )
  return finalSplit
}

const killScrollTriggerById = (id) => {
  const trigger = ScrollTrigger.getById(id)
  if (trigger) trigger.kill()
}

const runTextHeroIntroAnimation = ({
  rootSelector,
  introShown,
  heroAnimationComplete,
  hasSubtitle,
  hasBicolor,
}) => {
  gsap.config({
    force3D: true,
  })

  const lineSelector = `${rootSelector} .bicolor-line-container .bicolor-line`
  const titleSelector = `${rootSelector} .hero-title > h1 > span > span`
  const subtitleSelector = `${rootSelector} .subtitle`

  const initialTextAnimation = () => {
    if (heroAnimationComplete && !heroAnimationComplete.value) {
      heroAnimationComplete.value = true
    }

    if (hasBicolor) {
      gsap.fromTo(
        lineSelector,
        {
          x: '-100%',
        },
        {
          x: 0,
          duration: 2,
          ease: 'Power4.easeOut',
        }
      )
    }

    gsap.fromTo(
      titleSelector,
      {
        rotate: 0.001,
        y: '115%',
      },
      {
        y: 0,
        duration: 2,
        ease: 'Power4.easeOut',
        stagger: {
          amount: 0.2,
        },
      }
    )

    if (hasSubtitle) {
      gsap.fromTo(
        subtitleSelector,
        {
          autoAlpha: 0,
          y: 20,
        },
        {
          autoAlpha: 1,
          y: 0,
          duration: 1.5,
          ease: 'Power4.easeOut',
          delay: 0.5,
        }
      )
    }
  }

  const animationPack = () => {
    if (introShown.value) {
      initialTextAnimation()
    } else {
      setTimeout(() => {
        animationPack()
      }, 100)
    }
  }

  if (hasBicolor) {
    gsap.set(lineSelector, {
      x: '-100%',
    })
  }

  gsap.set(titleSelector, {
    rotate: 0.001,
    y: '115%',
  })

  animationPack()
}

export default function useHeroShared() {
  return {
    splitHeroText,
    killScrollTriggerById,
    runTextHeroIntroAnimation,
  }
}
